import React from 'react';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { OfferDetails } from '../components/OfferDetails';
import { FAQSection } from '../components/FAQSection';
import { PricingCTA } from '../components/PricingCTA';
import { Footer } from '../components/Footer';
export function SalesPage() {
  useMetaPixel();
  return <div className="min-h-screen font-sans text-brand-dark selection:bg-brand-teal selection:text-white" data-id="element-172">
      <HeroSection data-id="element-173" />
      <ProblemSection data-id="element-174" />
      <OfferDetails data-id="element-175" />
      <FAQSection data-id="element-176" />
      <PricingCTA data-id="element-177" />
      <Footer data-id="element-178" />
    </div>;
}